// 3rd Party libraries

import '/lib/promise.polyfill.min.js';
import 'whatwg-fetch';
import '/lib/jquery-3.4.0.min.js';
import '/lib/foundation-6.5.3.min.js';
import '/lib/lodash-4.17.11.min.js';
import '/lib/url-search-params-polyfill.js';
import '/lib/fuse-3.2.0.min.js';
import '/lib/closest.polyfill.js';

// SEE: https://github.com/bfred-it/object-fit-images/blob/c23e54985d82440ef12c8cfda46de2194506fea8/detailed-support-tables.md
import { objectFitImages } from '/lib/ofi-3.2.3.min.js';
import '/lib/picturefill-3.0.2.min.js'
document.addEventListener('DOMContentLoaded', function() {
	objectFitImages()
});

// AAMU JS files
// Files that start with _filename are added on a per page basis